<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #header>
          <EmailCampaignListHeader />
        </template>

        <template #default="dataTableProps">
          <EmailCampaignListItem
            :email-campaign="dataTableProps.item"
            @deleted="dataIteratorProps.resetList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { projectEmailCampaignsClient } from '@/api/clients';
import EmailCampaignListHeader from './EmailCampaignListHeader.vue';
import EmailCampaignListItem from './EmailCampaignListItem.vue';

export default {
  components: {
    EmailCampaignListHeader,
    EmailCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
  methods: {
    fetchData() {
      return projectEmailCampaignsClient.list(this.projectId, {
        include: ['emailAddressesCount', 'emailAddressesSentCount', 'emailAddressesFailedCount'],
      });
    },
  },
};
</script>
